import { TextField} from '@mui/material'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import {RootState} from '../../../setup'

const SocialSecurityNumberField = ({field, handleInputChange, formData}) => {
  const selectAuth = (state: RootState) => state.auth
  const auth = useSelector(selectAuth);
  const isCaregiver = auth.user?.isCaregiver;
  const ssnValue = formData[field.name] || '';

  function formatSSN(value, maskForCaregiver) {
    if (!value) return '';
    const cleanedValue = value.replace(/\D/g, '').slice(0, 9); 
  
    if (maskForCaregiver && cleanedValue.length === 9) {
      return `XXX-XX-${cleanedValue.slice(5, 9)}`;
    }
    const part1 = cleanedValue.slice(0, 3);
    const part2 = cleanedValue.slice(3, 5);
    const part3 = cleanedValue.slice(5, 9);
  
    let formattedValue = part1;
    if (part2) formattedValue += `-${part2}`;
    if (part3) formattedValue += `-${part3}`;
  
    return formattedValue;
  }
  return (
    <div>
    <TextField
      type='text'
      size='small'
      name={field.name}
      className='textField'
      value={isCaregiver ? `XXX-XX-${ssnValue.slice(-4)}` : formatSSN(ssnValue, isCaregiver)}
      onChange={(e) => {
        const {value} = e.target
        let formattedValue = value.replace(/[^0-9]/g, '').slice(0, 9)
        if (formattedValue.length > 3) {
          formattedValue = formattedValue.slice(0, 3) + '-' + formattedValue.slice(3)
        }
        if (formattedValue.length > 6) {
          formattedValue = formattedValue.slice(0, 6) + '-' + formattedValue.slice(6)
        }

        handleInputChange(e.target.name, formattedValue, '', e.target.type)
      }}
      variant='outlined'
      placeholder="XXX-XX-XXXX"
      required
      label='Social Security Number'
      autoComplete='off'
      error={Boolean(
        field.validation &&
          formData[field.name] &&
          !field.validation.pattern.test(formData[field.name])
      )}
      helperText={
        field.validation &&
        formData[field.name] &&
        !field.validation.pattern.test(formData[field.name])
          ? field.validation.message
          : ''
      }
      disabled={isCaregiver}
      />
    </div>
  )
}

export default SocialSecurityNumberField
